/**
 * 現在時刻を指定されたフォーマットでHTML要素に表示する関数だよ！
 * 「10:19 PM 2024.10.4 Fri」のような形式で表示するよ
 *
 * @example
 * // HTML要素に時間を表示する
 * updateDateTime();
 * // setIntervalで1秒ごとに更新する場合
 * setInterval(updateDateTime, 1000);
 */
const updateDateTime = () => {
    const now = new Date();
    const jstDate = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Tokyo" })
    );
    // 時間のフォーマット (12時間制)
    let hours = jstDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0時は12として表示
    const minutes = String(jstDate.getMinutes()).padStart(2, "0");

    // 日付のフォーマット
    const year = jstDate.getFullYear();
    const month = String(jstDate.getMonth() + 1).padStart(2, "0");
    const day = String(jstDate.getDate()).padStart(2, "0");

    // 曜日の取得
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const weekday = weekdays[jstDate.getDay()];

    const parent = document.querySelector(".Intel__date");

    if (parent) {
        // HTML要素に値を設定
        parent.querySelector(
            ".time"
        ).textContent = `${hours}:${minutes} ${ampm}`;
        parent.querySelector(".date").textContent = `${year}.${month}.${day}`;
        parent.querySelector(".day").textContent = weekday;
    }
};

// 初回実行
updateDateTime();

// 1秒ごとに更新（必要な場合）
setInterval(updateDateTime, 1000);
